import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "drg-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" MS "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" DRG ")
  ])
], -1)
const _hoisted_2 = { class: "drg-value" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "MCC-text" }, " 459 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-h8" }, " MCC ", -1)
const _hoisted_6 = { class: "col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "drg-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" APR "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" DRG ")
  ])
], -1)
const _hoisted_8 = { class: "drg-value" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "MCC-text" }, " 459 ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, " MCC ", -1)
const _hoisted_12 = { class: "col" }

import DualPane from 'components/global-common/DualPane.vue';
  import DisplayObject from 'components/global-common/DisplayObject.vue';
  import { useGrouperStore } from 'stores/GrouperStore';
  import {ref, Ref} from 'vue';

  import {DisplayObjectDataModel} from 'components/global-common/DisplayObjectData.model';
  import { useLayoutStore } from 'stores/layout-store';

  export interface Props{
      enableDualGrouping?: boolean,
      showApr?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperInfo',
  props: {
    enableDualGrouping: { type: Boolean, default: true },
    showApr: { type: Boolean, default: false }
  },
  emits: ["secondary-expanded"],
  setup(__props: any, { emit: __emit }) {

  const props = __props

  const emit = __emit

  const expandSecondary: Ref<boolean> = ref(props.showApr)

  const onSecondaryExpanded = (value: boolean) => {
      expandSecondary.value = value;
      useLayoutStore().expandCollapseApr();
      emit('secondary-expanded', expandSecondary.value)
      return expandSecondary.value;
  };

  const primaryDrg: Ref<DisplayObjectDataModel> = ref(
  {
      description: 'Use search bar, research view or add directly into the table',
      class: 'description',
      displayProperties: [
          {
              label: 'Weight',
              value: '0.9570',
              class: 'weight'
          },
          {
              label: 'GMLOS',
              value: '2.5',
              class: 'gmlos'
          },
          {
              label: 'MDC',
              value: '--',
              class: 'mdc'
          },
          {
              label: 'Type',
              value: 'MED',
              class: 'type'
          },
          {
              label: 'Est. Reimbursement',
              value: '$1,456.23',
              class: 'reimbursement'
          },
      ]
  });

  const secondaryDrg: Ref<DisplayObjectDataModel> = ref(
      {
          description: 'Use search bar, research view or add directly into the table',
          class: 'description',
          displayProperties: [
              {
                  label: 'Weight',
                  value: '0.9570',
                  class: 'weight'
              },
              {
                  label: 'GMLOS',
                  value: '2.5',
                  class: 'gmlos'
              }
          ]
      });



return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createBlock(DualPane, {
    horizontal: "",
    vertical: "",
    disable: "",
    beforeClass: "drg-pane",
    afterClass: "drg-pane",
    separatorClass: "",
    expanded: props.showApr,
    secondaryVisible: props.enableDualGrouping,
    dark: "",
    onSecondaryExpanded: onSecondaryExpanded
  }, {
    primary: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_q_btn, {
          unelevated: "",
          class: "iodine-icon-button text-none",
          round: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "fa-regular fa-edit",
              size: "18px"
            })
          ]),
          _: 1
        })
      ]),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_q_chip, { class: "MCC" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(DisplayObject, { "display-object-data": primaryDrg.value }, null, 8, ["display-object-data"])
      ])
    ]),
    secondary: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_q_btn, {
          unelevated: "",
          class: "iodine-icon-button text-none",
          round: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "fa-solid fa-arrows-rotate",
              size: "18px"
            })
          ]),
          _: 1
        })
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createVNode(_component_q_chip, { class: "MCC" }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(DisplayObject, { "display-object-data": secondaryDrg.value }, null, 8, ["display-object-data"])
      ])
    ]),
    _: 1
  }, 8, ["expanded", "secondaryVisible"]))
}
}

})